// Empty REACT_APP_API_URL = same origin as the website (production behind nginx)
export const serverUrl = process.env.REACT_APP_API_URL ?? 'http://localhost:5050';
export const url = `${serverUrl}/api/v1/`;
export const docViewUrl = (id) => `${url}documents/${id}/view`;
export const docDownloadUrl = (id) => `${url}documents/${id}/download`;
